import { Phone, Instagram, Facebook } from "lucide-react";
import { SITE } from "@/lib/site";

export const TopBanner = () => {
  return (
    <div
      data-testid="top-banner"
      className="w-full bg-brand-deep text-white text-[13px]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center justify-between gap-x-6 gap-y-2">
        <ul className="flex flex-wrap items-center gap-x-6 gap-y-1">
          {SITE.offices.map((o) => (
            <li key={o.id} className="flex items-center gap-2">
              <Phone className="w-3.5 h-3.5 text-brand-blush" strokeWidth={2} />
              <span className="text-white/70 uppercase tracking-[0.18em] text-[10px] font-semibold">
                {o.city}
              </span>
              <a
                href={o.phoneHref}
                data-testid={`top-banner-phone-${o.id}`}
                className="font-semibold hover:text-brand-blush transition-colors"
              >
                {o.phone}
              </a>
            </li>
          ))}
        </ul>
        <div className="flex items-center gap-1.5">
          <span className="text-white/60 text-[11px] uppercase tracking-[0.18em] font-semibold mr-2 hidden sm:inline">
            Follow us
          </span>
          <a
            href={SITE.social.instagram}
            target="_blank"
            rel="noreferrer"
            aria-label="Embrace Healthcare on Instagram"
            data-testid="top-banner-instagram"
            className="w-7 h-7 rounded-full bg-white/10 hover:bg-brand-blush hover:text-brand-deep flex items-center justify-center transition-colors"
          >
            <Instagram className="w-3.5 h-3.5" strokeWidth={2} />
          </a>
          <a
            href={SITE.social.facebook}
            target="_blank"
            rel="noreferrer"
            aria-label="Embrace Healthcare on Facebook"
            data-testid="top-banner-facebook"
            className="w-7 h-7 rounded-full bg-white/10 hover:bg-brand-blush hover:text-brand-deep flex items-center justify-center transition-colors"
          >
            <Facebook className="w-3.5 h-3.5" strokeWidth={2} />
          </a>
        </div>
      </div>
    </div>
  );
};
